import { Mixins, Component } from 'vue-property-decorator';
import { MyContentViewsMixin } from '../../../../mixins/my-content-views.mixin';
import { MY_CONTENT_MENU_NAME } from '@/app/private/my-content/values/my-content.values';
import EdCreateContentCard from '../../../../components/ed-create-content-card/ed-create-content-card.vue';
import { CORE_ROUTES } from '@/core/core.router';

@Component({
  name: 'contents',
  components: {
    EdCreateContentCard
  }
})
export default class Contents extends Mixins(MyContentViewsMixin) {

  public page: string = '';
  public type: string = '';
  public title: string = '';
  public isLoadingMore: boolean = false;

  get contentList(): any[] {
    return this.$store.state.MyContentStore[this.page].courses.content;
  }

  get hasMore(): boolean {
    return this.$store.state.MyContentStore[this.page].courses.hasMorePages;
  }

  get isSubjectsPage(): boolean {
    return this.page == MY_CONTENT_MENU_NAME.SUBJECTS;
  }

  get isFirsLoading() {
    return this.isCoursesLoading;
  }

  async loadMore() {
    this.isLoadingMore = true;
    await this.getCourses(false);
    this.isLoadingMore = false;
  }

  goToCreateElement() {
    this.$router.push({
      name: CORE_ROUTES.CREATE_COURSE.NAME
    });
  }

  created() {
    this.page = this.$route.params.page;
    this.type = this.$route.params.type;
    this.title = String(this.$i18n.t(`myContent.all.courses${this.page}`));
  }
  
}
